import React, { useCallback, useMemo } from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { PlaceLink } from 'utils/link';
import { IndexListItemButton } from 'components/styles_components/list';
import Place from 'utils/place';
import useMobile from 'hooks/use_mobile';

const ListItem = ({ place }) => {
  const navigate = useNavigate();
  const isMobile = useMobile();

  const placeUtil = useMemo(() => Place(place), [place]);
  const nameGridWidth = useMemo(() => (isMobile ? 12 : 6), [isMobile]);

  const handleClick = useCallback(() => {
    navigate(PlaceLink(place.id));
  }, [navigate, place.id]);

  return (
    <IndexListItemButton className={placeUtil.htmlClass} onClick={handleClick}>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={nameGridWidth}>
          <Stack>
            <Typography variant="button">{place.name}</Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              {place.street}, {place.zipCode} {place.city}
            </Typography>
            {place.phone && (
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                {place.phone}
              </Typography>
            )}
          </Stack>
        </Grid>
        {!isMobile && (
          <>
            <Grid textAlign="center" size={{ xs: 3 }}>
              <Typography color={placeUtil.incomingInspectionsColor} variant="button">
                {place.incomingInspectionsTotal}
              </Typography>
            </Grid>
            <Grid textAlign="center" size={{ xs: 3 }}>
              <Typography color={placeUtil.overdueInspectionsColor} variant="button">
                {place.overdueInspectionsTotal}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </IndexListItemButton>
  );
};

export default React.memo(ListItem);
